import React from 'react';
import { Flex, Box, Text, Divider } from '@chakra-ui/react';
import { useDispatch, useTrackedState } from '../../config/store';

function StyledFilterMenuButton({ interviewStatusFilter, buttonName }) {
  const dispatch = useDispatch();
  const state = useTrackedState();

  return (
    <Text
      as='button'
      fontWeight='700'
      letterSpacing='-0.2px'
      p='8px'
      pt={buttonName === interviewStatusFilter && '9px'}
      borderBottom={buttonName === interviewStatusFilter ? 'solid 2px' : null}
      color={buttonName === interviewStatusFilter ? 'gray.900' : 'gray.600'}
      _hover={{
        pt: '9px',
        borderBottom: 'solid 2px',
        transition: 'all 0.1s',
      }}
      onClick={() => {
        dispatch({
          type: 'GET_INTERVIEWS_PAGINATION_PARAMS',
          token: state.user.token,
          page: 1,
          interviewStatusFilter: buttonName,
        });
      }}>
      {buttonName}
    </Text>
  );
}

function InterviewStatusFilterMenu({ interviewStatusFilter, setInterviewStatusFilter }) {
  return (
    <Box width='558px'>
      <Flex justifyContent='space-between' alignItems='center'>
        <StyledFilterMenuButton
          setInterviewStatusFilter={setInterviewStatusFilter}
          interviewStatusFilter={interviewStatusFilter}
          buttonName='All Interviews'
        />

        <Box height='16px'>
          <Divider orientation='vertical' borderColor='gray.600' />
        </Box>

        <StyledFilterMenuButton
          setInterviewStatusFilter={setInterviewStatusFilter}
          interviewStatusFilter={interviewStatusFilter}
          buttonName='Scheduled'
        />

        <Box height='16px'>
          <Divider orientation='vertical' borderColor='gray.600' />
        </Box>

        <StyledFilterMenuButton
          setInterviewStatusFilter={setInterviewStatusFilter}
          interviewStatusFilter={interviewStatusFilter}
          buttonName='Report Pending'
        />

        <Box height='16px'>
          <Divider orientation='vertical' borderColor='gray.600' />
        </Box>

        <StyledFilterMenuButton
          setInterviewStatusFilter={setInterviewStatusFilter}
          interviewStatusFilter={interviewStatusFilter}
          buttonName='Missing Video'
        />

        <Box height='16px'>
          <Divider orientation='vertical' borderColor='gray.600' />
        </Box>
        <StyledFilterMenuButton
          setInterviewStatusFilter={setInterviewStatusFilter}
          interviewStatusFilter={interviewStatusFilter}
          buttonName='Completed'
        />
      </Flex>
    </Box>
  );
}

export default InterviewStatusFilterMenu;
